import React from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';
import { useNavigate } from "react-router-dom";
import { Pagination } from 'antd';
const CardList = ({ list, total, pageParam, setPageParam, type }) => {
	const navigate = useNavigate();
	const goToDetail = (id, link) => {
		if (link) {
			window.open(link, '_blank');
		} else {
			navigate(`/detail?id=${id}&type=${type}`)
		}
	};
	return (
		<div className={styles.cardListBox}>
			{
				list.map((item, index) => {
					return (
						<div className={classNames('flex_box')} key={index + type} onClick={() => goToDetail(item.id, item.link)}>
							<img src={process.env.REACT_APP_API_AFFIX+"/file/preview?filePath=" + item.imgPath} />
							<div className={styles.rightBox}>
								<span>{item.type}</span>
								<h2>{item.title}</h2>
								<div>{item.des}</div>
								<span>{item.date}</span>
							</div>
						</div>
					)
				})
			}

			<Pagination
				align="end"
				current={pageParam.currentPage}
				pageSize={pageParam.pageSize}
				total={total}
				showSizeChanger={false}
				showQuickJumper
				onChange={(page, pageSize) => {
					setPageParam({
						currentPage: page,
						pageSize: pageSize,
					});
				}}
			/>
		</div>
	)
}
export default CardList;